import { PayloadAction } from "@reduxjs/toolkit";
import { FinanceState } from "../../models/FinanceState";
import { GetVendorMoneyTransactionsPayload } from "../../payload/GetVendorMoneyTransactions/GetVendorMoneyTransactionsPayload";

const getVendorMoneyTransactionsFetch = (state: FinanceState, action: PayloadAction<GetVendorMoneyTransactionsPayload>) => {
    state.isLoading = true;
}

export default getVendorMoneyTransactionsFetch;